import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable()
export class TitleRegistrationUserService extends BaseApiService {

    getCustomerUserAgentCustomerNumbers(): Observable<any> {
        return this.get('Foundation/User/CustomerUserAgentCustomerNumbers').pipe(map(r => r.result));
    }
}
